import Pusher from 'pusher-js'
import { getDeviceSerial } from '../utils/deviceData'

// CHANNELS
export const CHANNEL_PRIVATE_POS_VENUE = `private-pos-${process.env.REACT_APP_VENUE_UUID}`

// EVENTS
export const PUSHER_EVENT_ORDER_MUTATION = 'order-mutation'
export const PUSHER_EVENT_ORDER_TRANSFERRED = 'order-transferred'
export const PUSHER_EVENT_ORDER_CREATED = 'order-created'

// BINDS
export const BIND_ORDERS_MUTATION = 'BIND_ORDERS_MUTATION'
export const BIND_CUSTOMER_TABS_MUTATION = 'BIND_CUSTOMER_TABS_MUTATION'
export const BIND_PAYMENT_INDEX = 'BIND_PAYMENT_INDEX'
export const BIND_RICH_CHECKOUT_CONTAINER = 'BIND_RICH_CHECKOUT_CONTAINER'
export const BIND_RICH_CHECKOUT_CONTAINER_ORDER_CREATED = 'BIND_RICH_CHECKOUT_CONTAINER_ORDER_CREATED'

export class VNPusher {
  constructor(pusherKey, pusherCluster, errorCallback = () => {}) {
    this.apiKey = pusherKey
    this.apiCluster = pusherCluster

    this.socketSetup()

    // setup a channels map to there is only one subscribe per react instance
    this.channels = {}

    // setup a binds map to only create one bind each time the dev actually ones to receive the message
    // the bind isn't idompotent, every bind is unique. The value inside this map is NOT used
    this.binds = {}

    // error callback
    this.errorCallback = errorCallback
  }

  getDeviceChannel() {
    const deviceSerial = getDeviceSerial()
    return `private-source-device-${deviceSerial}`
  }

  socketSetup() {
    this.socket = new Pusher(this.apiKey, {
      cluster: this.apiCluster,
      authEndpoint: `${process.env.REACT_APP_OIDC_ISSUER}/pusher/auth`,
      forceTLS: true,
      auth: {
        params: {
          bearer_token: localStorage.getItem('accessToken'),
        },
      },
    })

    // Callback for failed connections
    this.socket.connection.bind('failed', (err) => {
      this.errorCallback(err)
    })

    // Callback for connection errors
    this.socket.connection.bind('error', (err) => {
      this.errorCallback(err)
    })

    // check for state to change to successful connection
    this.socket.connection.bind('state_change', (states) => {
      if (states.current === 'unavailable') {
        this.errorCallback({ message: 'Connection is unavailable' })
      }
    })
  }

  // need to add callback for failed connections
  subscribe(channelName) {
    if (!this.channels[channelName]) {
      this.channels[channelName] = this.socket.subscribe(channelName)
    }
  }

  unsubscribe(channelName) {
    if (this.channels[channelName]) {
      this.socket.unsubscribe(channelName)
      this.socket.disconnect()
      delete this.channels[channelName]
    }
  }

  bind(uniqueBindId, channelName, eventName, eventFunc) {
    if (!this.binds[uniqueBindId]) {
      this.channels[channelName].bind(eventName, eventFunc)
      this.binds[uniqueBindId] = 'exists'
    }
  }

  resetSocket() {
    if (this.socket === null) return
    Object.keys(this.channels).forEach((channelName) => {
      this.unsubscribe(channelName)
    })
    Object.keys(this.binds).forEach((bindId) => {
      delete this.binds[bindId]
    })
    this.socket = null
  }

  subscribeDeviceChannel() {
    this.subscribe(this.getDeviceChannel())
  }

  unsubscribeDeviceChannel() {
    this.unsubscribe(this.getDeviceChannel())
  }

  bindOrderTransfered(callback) {
    this.bind(BIND_RICH_CHECKOUT_CONTAINER, this.getDeviceChannel(), PUSHER_EVENT_ORDER_TRANSFERRED, callback)
  }

  bindOrderCreated(callback) {
    this.bind(BIND_RICH_CHECKOUT_CONTAINER_ORDER_CREATED, this.getDeviceChannel(), PUSHER_EVENT_ORDER_CREATED, callback)
  }
}
